import gravatar from 'gravatar'

export const getGravatarUrl = (email: string) =>
  gravatar.url(email, {
    default: 'https://www.forgeglobal.com/static/app/default_user.jpg',
    size: '100px',
  })
